













import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "StepBar",
  props: {
    stepCount: {
      type: Number as PropType<Props["stepCount"]>,
      required: true
    },
    currentStep: {
      type: Number as PropType<Props["stepCount"]>,
      required: true
    }
  },
  computed: {
    stepBarStyle() {
      const stepSize = 20;
      const stepLineWidth = 64;
      return {
        width: `${(stepSize + stepLineWidth) * this.stepCount -
          stepLineWidth}px`
      };
    }
  },
  methods: {
    isVisited(step) {
      return step <= this.currentStep;
    }
  }
});
